import React from "react";
import { Link } from "react-router-dom";
import { TID } from "../lib/testIds";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      data-testid={TID.footer}
      className="relative bg-canvas border-t border-hairline"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo
              variant="full"
              className="h-32 md:h-40 w-auto text-primary-x"
            />
            <p className="mt-8 text-secondary-x leading-relaxed max-w-sm">
              A boutique software studio building products, AI systems and
              security for ambitious teams.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.25em] uppercase text-muted-x font-mono-x mb-4">
              Studio
            </div>
            <ul className="space-y-3 text-secondary-x text-sm">
              <li><Link className="hover:text-primary-x transition-colors" to="/services">Services</Link></li>
              <li><Link className="hover:text-primary-x transition-colors" to="/work">Work</Link></li>
              <li><Link className="hover:text-primary-x transition-colors" to="/process">Process</Link></li>
              <li><Link className="hover:text-primary-x transition-colors" to="/about">About</Link></li>
              <li><Link className="hover:text-primary-x transition-colors" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.25em] uppercase text-muted-x font-mono-x mb-4">
              Resources
            </div>
            <ul className="space-y-3 text-secondary-x text-sm">
              <li><Link className="hover:text-primary-x transition-colors" to="/blog">Blog</Link></li>
              <li><Link className="hover:text-primary-x transition-colors" to="/components">Components</Link></li>
              <li><Link className="hover:text-primary-x transition-colors" to="/logo">Logo</Link></li>
              <li><Link className="hover:text-primary-x transition-colors" to="/brand">Brand</Link></li>
              <li><Link className="hover:text-primary-x transition-colors" to="/sponsor">Sponsor</Link></li>
              <li><Link className="hover:text-primary-x transition-colors" to="/careers">Careers</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.25em] uppercase text-muted-x font-mono-x mb-4">
              Elsewhere
            </div>
            <ul className="space-y-3 text-secondary-x text-sm">
              <li><a className="hover:text-primary-x transition-colors" href="#" onClick={(e) => e.preventDefault()}>X / Twitter</a></li>
              <li><a className="hover:text-primary-x transition-colors" href="#" onClick={(e) => e.preventDefault()}>LinkedIn</a></li>
              <li><a className="hover:text-primary-x transition-colors" href="#" onClick={(e) => e.preventDefault()}>GitHub</a></li>
              <li><a className="hover:text-primary-x transition-colors" href="mailto:hello@ulties.com">hello@ulties.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-hairline flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-muted-x font-mono-x tracking-[0.18em] uppercase">
          <div>© {new Date().getFullYear()} Ulties Studio · All rights reserved</div>
          <div className="flex items-center gap-5 flex-wrap">
            <Link to="/terms" className="hover:text-primary-x transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-primary-x transition-colors">Privacy</Link>
            <span className="inline-flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,0.6)]" />
              Systems online
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
